import { Component, EventEmitter, Input, TemplateRef, ViewChild } from '@angular/core';
import { Roles } from '@nrwl/rx-models';

@Component({
  selector: 'rx-tab',
  templateUrl: './rx-tab.component.html',
  styleUrls: ['./rx-tab.component.scss'],
})
export class RxTabComponent {
  constructor() {}

  @ViewChild('innerTemplate', { static: true }) public innerTemplate: TemplateRef<any>;

  @Input()
  public disabled = false;

  @Input()
  public rejectedRoles: Roles[] = [];

  public selectedIndex = 0;
  public selectedIndexChange = new EventEmitter<any>();
}
